import React from "react";
import GetStartedWidget from "../get_started/main/GetStartedWidget";
import FeatureWidget from "../feature/FeatureWidget";
import SupportWidget from "../support/SupportWidget";
import {withRouter, Route, Switch} from "react-router-dom";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import styled from "styled-components";
import AppPrivacyPolicy from "../app_privacy_policy/AppPrivacyPolicy";
import Imprint from "../app_privacy_policy/Imprint";

function RouteContainer({appStyle, location}) {
    return (
        <Wrapper>
            <TransitionGroup className="transition-group">
                <CSSTransition
                    key={location.key}
                    timeout={{enter: 300, exit: 300}}
                    classNames="fade"
                >
                    <section className="route-section">
                        <Switch location={location}>
                            <Route exact path="/" render={(props) => <GetStartedWidget appStyle={appStyle}/>}/>
                            <Route exact path="/explore" render={(props) => <FeatureWidget appStyle={appStyle}/>}/>
                            <Route exact path="/support" render={(props) => <SupportWidget appStyle={appStyle}/>}/>
                            <Route exact path="/capture-n-paste-privacy-policy" render={(props) => <AppPrivacyPolicy appStyle={appStyle} />}/>
                            <Route exact path="/imprint" render={(props) => <Imprint appStyle={appStyle} />}/>
                        </Switch>
                    </section>
                </CSSTransition>
            </TransitionGroup>
        </Wrapper>
    );
}

/*
  Transition relevant CSS-enriched Wrapper element
 */
const Wrapper = styled.div`
    .fade-enter {
        opacity: 0.01;
    }
    .fade-enter.fade-enter-active {
        opacity: 1;
        transition: opacity 200ms ease-in;
    }
    .fade-exit {
        opacity: 1;
    }
      
    .fade-exit.fade-exit-active {
        opacity: 0.01;
        transition: opacity 200ms ease-in;
    }
    
    div.transition-group {
           position: relative;
      }
      section.route-section {
        position: relative;
        width: 100%;
        top: 0;
        left: 0;
      }
`;

export default withRouter(RouteContainer);